<template>
    <div :class="$attrs.class">
        <label v-if="label" class="form-label">{{ label }}:<span v-if="required" class="text-red-500">*</span></label>
        <div :class="{'flex flex-wrap':inline === true}" >
            <div v-for="option in options" :key="option.id" class="flex items-center mr-4">
                <label :for="option.name+option.value" class="wrapper flex items-center">
                    <input :id="option.name+option.value" v-model="checkboxValues" :name="option.name" :value="option.value"
                        :checked="isChecked(option)" class="checkbox" type="checkbox" @change="handleCheckboxChange" />
                    <span class="checkmark pr-2" />
                    {{ option.label }}
                </label>
            </div>
        </div>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
/* eslint-disable */
import { v4 as uuid } from 'uuid'

export default {
    inheritAttrs: false,

    model: {
        prop: 'modelValue',
        event: 'change',
    },

    props: {
        'modelValue': { type: Array, default: [] },
        'value': { type: String },
        inline: {type: Boolean, default:true },
        required: String,
        options: {
            type: Array,
        },
        id: {
            type: String,
            default() {
                return `select-input-${uuid()}`
            },
        },
        error: String,
        label: String,
    },

    data() {
        return {
            selected: this.modelValue,
            checkboxValues: [],
        }
    },
    watch: {
        selected(selected) {
            this.$emit('update:modelValue', selected)
        },
        modelValue(modelValue) {
            this.selected = modelValue
        },
    },

    mounted() {
        this.checkboxValues = this.modelValue;
    },

    methods: {
        isChecked(option) {
            return this.modelValue.indexOf(option.value) >= 0
        },
        handleCheckboxChange() {
            this.$emit('update:modelValue', this.checkboxValues)
        },
    },
}
</script>
